<template>
    <div>
        <b-row>
            <b-col cols="0" sm="3"	md="4"	lg="4"	xl="4"></b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                <div class="col-md-12 text-center">
                    <b-button variant="secondary" @click="listOrdenPago"><i class="fa fa-sync-alt"></i> </b-button>
                </div>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2"></b-col>
            <b-col md="2">
                <b-form-group horizontal label="Mostrar">
                <b-input-group>
                    <b-form-select v-model="limite" slot="append" @input="listOrdenPago">
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </b-form-select>
                </b-input-group>
            </b-form-group>
            </b-col>
        </b-row><br>
        <b-row>
            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                <b-table 
                    responsive
                    small
                    striped
                    outlined
                    :items="ordenpagos"
                    :fields="ordenpagos_fields"
                    :current-page="pactual"
                    :per-page="limite"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :busy="isBusy"
                    @filtered="onFiltered"
                    >
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template slot="emision" slot-scope="row">
                        {{ row.item.created_at | moment('D/M/Y hh:mm:ss A') }}
                    </template>
                    <template slot="fvencimiento" slot-scope="row">
                        <template  v-if="row.item.ordenPago.fvencimiento">
                        <h5> <b-badge  variant="info"> {{row.item.ordenPago.fvencimiento}}</b-badge> </h5>    
                        </template>
                    </template>
                    <template slot="receptor" slot-scope="row">
                        <template v-if="row.item.ordenPago.receptor">
                            {{row.item.ordenPago.receptor.nro}} - {{row.item.ordenPago.receptor.razonSocial}}
                        </template>
                    </template>
                     <template slot="usuario" slot-scope="row">
                        <template v-if="row.item.ordenPago.adicional && row.item.ordenPago.adicional.username">
                            {{row.item.ordenPago.adicional.username}}
                        </template>
                        <template v-else>
                                Sin usuario
                        </template>
                    </template>
                    <template slot="tag3" slot-scope="row">
                            {{row.item.ordenPago.tag3}}
                     </template>                 
                    <template slot="montoTotal" slot-scope="row">
                        <template v-if="row.item.ordenPago.moneda">
                        {{ row.item.ordenPago.moneda.simbolo }} 
                        </template>
                        {{ row.item.ordenPago.totales.importeTotal.toFixed(2) }} 
                    </template>
                    <template slot="pagado" slot-scope="row">
                        <template v-if="row.item.pagado == '1'">
                           <b-badge variant="success" >Pagado</b-badge>
                        </template>
                        <template v-if="row.item.pagado == '0'">
                           <b-badge variant="warning">Por pagar</b-badge>
                        </template>
                    </template>
                    <template slot="documento" slot-scope="row">
                        {{row.item.seriePagado}} - {{row.item.numeroPagado}}    
                    </template>
                    <template slot="acciones" slot-scope="row">
                        <b-button-group>
                            <button size="sm" @click="row.toggleDetails" type="button" class="btn" title="Mas opciones">
                                <template v-if="!row.detailsShowing">
                                    <i class="fa fa-plus"></i>
                                    
                                </template>
                                <template v-else>
                                    <i class="fa fa-minus"></i>
                                </template>
                            </button>
                            <template v-if="row.item.pagado == 1">
                                 <b-button disabled size="sm" variant="primary"><i class="fa fa-pencil-alt" title="Editar Proforma"></i></b-button>
                            </template>
                            <template v-else>
                                 <b-button  size="sm" v-b-tooltip.hover variant="primary" @click="returnProforma(row.index, row.item)"><i class="fa fa-pencil-alt" title="Editar Proforma"></i></b-button>
                            </template>
                            <b-button size="sm" v-b-tooltip.hover variant="secondary" @click="sendPdf(row)"><i class="fa fa-tv" title="Ver Proforma"></i></b-button>
                            <b-button size="sm" v-b-tooltip.hover variant="secondary" @click="downloadPdf(row.item)"><i class="fa fa-download" aria-hidden="true"></i></b-button>
                            <b-button size="sm" v-b-tooltip.hover v-b-modal.sendordenpagoemail1 variant="secondary" @click="dataSendMail(row.item)"><i class="fa fa-envelope" title="Enviar por Correo (Proximanente)"></i></b-button>
                            <template v-if="row.item.pagado == 1">
                                <b-button disabled size="sm" variant="dark" ><b title="Convertir a Factura">F</b></b-button>
                                <b-button disabled size="sm" variant="dark" ><b title="Convertir a Boleta">B</b></b-button>
                                <b-button disabled size="sm" variant="danger"><i class="fa fa-trash"></i></b-button>
                            </template>
                            <template v-else>
                                <b-button v-b-modal.messageConvert size="sm" v-b-tooltip.hover variant="dark" @click="sendDataOrdenpago(row.item, 1)"><b title="Convertir a Factura">F</b></b-button>
                                <b-button v-b-modal.messageConvert size="sm" v-b-tooltip.hover variant="dark" @click="sendDataOrdenpago(row.item, 2)"><b title="Convertir a Boleta (Proximanente)">B</b></b-button>
                                <b-button size="sm" v-b-modal.sendfacturaemail1 v-b-tooltip.hover variant="danger" @click="predeleteProforma(row.item)"><i class="fa fa-trash" title="Eliminar Proforma"></i></b-button>
                            </template>
                            
                            <!-- <b-button v-b-modal.messageConvert size="sm" v-b-tooltip.hover variant="dark" @click="sendDataOrdenpago(row.item, 3)"><b title="Convertir a Guia (Proximanente)">G</b></b-button> -->
                        </b-button-group>  
                    </template>
                    <template v-slot:row-details="row">
                        <b-card>
                            <b-table
                            head-variant="light"
                            :outlined="outlined"
                            striped
                            hover
                            :items="row.item.ordenPago.items"
                            :fields="listaitems_fields"
                            :busy="row.item.loading"
                            >
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                            </div>
                            <template slot="index" slot-scope="row">{{ row.index+1 }}</template>
                            <template slot="cantidad" slot-scope="row">
                                <div>
                                    <template v-if="row.item.cantidad">
                                        {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                                    </template>
                                </div>
                            </template>
                            <template slot="precioVentaUnitario" slot-scope="row">
                                <div>
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template
                                    v-if="row.item.precioVentaUnitario"
                                >{{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}</template>
                                </div>
                            </template>
                            <template slot="descuento" slot-scope="row">
                                <div>
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                    <template v-if="row.item.descuento">
                                        {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                                    </template>
                                </div>
                            </template>
                            <template slot="valorVenta" slot-scope="row">
                                <div>
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template v-if="row.item.tipoAfectacionIgv !='30' && row.item.tipoAfectacionIgv !='20'"
                                    >{{ Number.parseFloat(row.item.valorVenta*(row.item.porcentajeImpuesto == '18.00000' ? 1.18 : 1.105)).toFixed(2) }}
                                </template>
                                <template v-else
                                    >{{ Number.parseFloat(row.item.valorVenta).toFixed(2)}}
                                </template>
                                    <div v-if="row.item.porcentajeImpuesto !='0'" style="float:right;color:red">
                                        {{row.item.porcentajeImpuesto == '18.00000' ? '18%' : '10.5%'}}
                                    </div>
                                    <div v-else style="float:right;color:red">
                                        18%
                                    </div>
                                </div>
                            </template>
                            </b-table>
                            <label v-if="row.item.ordenPago.observaciones != null" style="color:red">observaciones: </label> {{row.item.ordenPago.observaciones}} 
                            <label v-if="row.item.ordenPago.atencion != null" style="color:red">Atencion: </label> {{row.item.ordenPago.atencion}} 
                            <label v-if="row.item.ordenPago.plazoentrega != null" style="color:red">Plazo Entrega: </label> {{row.item.ordenPago.plazoentrega}} 
                            <label v-if="row.item.ordenPago.formapago != null" style="color:red">Forma de Pago: </label> {{row.item.ordenPago.formapago}} 
                            <label v-if="row.item.ordenPago.garantia != null" style="color:red">Garantia: </label> {{row.item.ordenPago.garantia}} 
                            <label v-if="row.item.ordenPago.telefono != null" style="color:red">Telefono: </label> {{row.item.ordenPago.telefono}} 
                        </b-card>
                    </template>
                </b-table>
                <b-row>
                    <b-col cols="12"	sm="4"	md="6"	lg="8"	xl="8">
                        <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                    </b-col>
                    <b-col cols="12"	sm="8"	md="6"	lg="4"	xl="4">
                        <b-pagination size="sm" :total-rows="total" v-model="currentPage" :per-page="limite" @input="listOrdenPago"></b-pagination>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-modal id="pdfordenpago" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="pdfordenpago">
            <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
            <template v-else>
            <template v-if="pdfobject !==''">
                <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
            </template>
            </template>
        </b-modal>
        <b-modal id="messageConvert" size="lg" title="Informativo Telemovil" cancel-title="Cerrar" v-model="noticeConvert">
        <b-row>
            <b-col cols="7">
                <img src="images/informativo.png" alt="Logo">
            </b-col>
            <b-col cols="5">
                <br><br><br><br><br>
                <p class="notice">{{ bodycomment }}</p>
                <br>
                <h5 v-if="tipoDocConvert===3">Nota: A excepcion de los items por servicios</h5>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-btn size="md" variant="primary" @click="convertInvoice()">
                Continuar
            </b-btn>
        </div>
    </b-modal>
    <b-modal id="sendordenpagoemail1" title="Enviar por Correo" v-model="previacorreo">

        <div style="background-color: #cce6ff" class="p-2" role="group">
        <label for="inputLive">Enviar por Correo: <i class="fa fa-envelope fa-lg" aria-hidden="true"></i></label> 
        <b-form-input style="border-color:black" v-model="recipients" type="email" @keyup.enter="sendMail(invoice)"></b-form-input>
        <b-form-text 
          style="font-size: small !important; color: #ea0909 !important"
        >Ingresa un correo ó varios separados por comas (,)</b-form-text>
      
        <b-row>
          <b-col cols="9"></b-col>
          <b-col>
            <b-btn
              v-if="!sendcorreo"
              size="sm"
              variant="primary"
              @click="sendMail(invoice)"
            >Enviar
            </b-btn>
            <b-btn v-else-if="recipients!=''" size="sm" class="float-right" variant="secondary">
              <i class="fa fa-spin fa-spinner"></i> Enviando...
            </b-btn>
          </b-col>
        </b-row>
      <hr class="mt-3">
        <h5>Correos en módulo Negocios:</h5>
        <h5><li style="list-style:none" class="mr-1" variant="dark" v-for="(item,index) in reciveEmail" :key="index">
        <b-badge pill variant="light">{{item}}
        <i @click="borrarCorreo(index)" class=" fa fa-times-circle text-dark cursor"></i></b-badge> 
        </li>
        </h5>
        <b-row>
          <b-col cols="9"></b-col>
          <b-col>
            <template  v-if="!sendcorreoTerceros">
            <b-button v-if="recipients!=''" :disabled="mostraremail" size="sm" @click="enviarEmail(invoice)" variant="primary">Enviar a todos</b-button>
            <b-button v-else  :disabled="mostraremail" size="sm" @click="enviarEmail(invoice)" variant="primary">Enviar</b-button>
        </template>
        <template  v-else>
            <b-btn size="sm" class="float-right" variant="secondary">
              <i class="fa fa-spin fa-spinner"></i> Enviando...
            </b-btn>
        </template>
            
          </b-col>
        </b-row>
        <div slot="modal-footer"></div>
        </div>
    </b-modal>
    <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import download from "downloadjs";
import axios from 'axios'
import ModalPreview from '@/components/factura/complementos/ModalPreview'
    export default {
       name: 'OrdenPagoConsulta',
       components: {
           ModalPreview
       },
       data: () => {
           return {
                previacorreo: false,
                sendcorreo: false,
                sendcorreoTerceros: false,
                recipients: '',
                bodycomment: 'Esta a punto de convertir esta Orden de Pago en Factura',
                noticeConvert: false,
                total: 0.00,
                desde: 0.00,
                hasta: 0.00,
                totalRows: 0,
                cargandopdf2: false,
                pdfobject: null,
                pdfordenpago: false,
                cargando: false,
                small: true,
                striped: true,
                outlined: true,
                pactual: 1,
                limite: 10,
                sortBy: null,
                sortDesc: false,
                sortDirection: 'desc',
                ordenpago: {},
                ordenpagos: [],
                ordenpagos_fields: [
                    {key: 'serie', label: 'Serie', sorteable: true},
                    {key: 'numero', label: 'Numero', sorteable: true},
                    {key: 'emision', label: 'Emisión', sorteable: true},
                    {key: 'fvencimiento', label: 'vt.º', sorteable: true},
                    {key: 'receptor', label: 'Receptor', sorteable: true},
                    {key: 'usuario', label: 'Usuario', sorteable: true},
                    {key: 'tag3', label: 'Etiqueta', sorteable: true},       
                    {key: 'montoTotal', label: 'Monto Total', sorteable: true},
                    {key: 'pagado', label: 'Estado', sorteable: true},
                    {key: 'documento', label: 'Documento', sorteable: true},
                    {key: 'acciones', label: 'Acciones'}
                ],
                listaitems_fields: [
                    { key: "index" },
                    { key: "codigoProducto", label: "Codigo", sorteable: true },
                    { key: "unidadMedidaCantidad", label: "Unidad", sorteable: true },
                    { key: "descripcion", label: "Descripción", sorteable: true },
                    { key: "observacion", label: "Observación", sorteable: true },
                    { key: "cantidad", label: "Cantidad", sorteable: true },
                    { key: "precioVentaUnitario", label: "Precio Unit", sorteable: true },
                    { key: "descuento", label: "Descuento", sorteable: true },
                    { key: "valorVenta", label: "Precio Total", sorteable: true }
                ],
                isBusy: false,
                bufferData: {},
                tipoDocConvert: 1,
                currentPage: 1,
                sistema:"facturaonline",
                customers:[],
                reciveEmail:[],
                mostraremail: true,
                cargandopdf: false,
           }
       },
       created() {
            this.listOrdenPago()
       },
       mounted() {
           this.initReturn()
           this.listTerceros();
       },
       methods: {
           onFiltered (filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
           },
           borrarCorreo(index){
            this.reciveEmail.splice(index, 1)
                if(this.reciveEmail.length > 0){
                    this.mostraremail = false;
                }else{
                    this.mostraremail = true;
                }
            },
           dataSendMail: function (data) {
                this.listTerceros();
                this.ordenpago = data
                this.invoice = data;
                let valordata = data
                let pasandoCorreoTerceros = {}
                this.customers.forEach(function(element){
                    if(valordata.ordenPago.receptor.nro == element.documento){
                    pasandoCorreoTerceros = element.emailEnvio
                    }      
                })
                this.reciveEmail = pasandoCorreoTerceros;
                if(this.reciveEmail && this.reciveEmail.length > 0){
                    this.mostraremail = false;
                }else{
                    this.mostraremail = true;
                }
           },
           listTerceros: function() {
            axios
                .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
                token: this.$store.getters.userToken,
                page: this.currentPageTerceros,
                order: this.ordenTerceros
                })
                .then(response =>(
                    this.customers = response.data
                ))
                .catch(error => (
                console.log(error)
                ))
            },
            enviarEmail: function(data) {
            for (let i = 0; i < this.reciveEmail.length; i++) {
                this.reciveEmail[i] + ","
            }
            let cadena = this.reciveEmail.join(",");
            if(this.recipients !=''){
                this.sendMail(data);  
            }  
            this.sendcorreoTerceros = true;
    
            axios
                .post(process.env.VUE_APP_API_URL + "ordenpago/pdf/mail", {
                    token: this.$store.getters.userToken,
                    id: this.ordenpago.idOrdenPago,
                    mail: cadena
                })
                .then(
                response => (
                    this.sendcorreoTerceros = false,
                    this.$snotify.success(response.data.msg, 'Exito')
                )
                )
                .catch(
                error => (
                    this.sendcorreoTerceros = false,
                    this.$snotify.error(error.response.data.response, 'Error')
                )
                );
            },
           sendMail: function () {
               this.previacorreo = true,
                this.sendcorreo = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'ordenpago/pdf/mail', {
                    token: this.$store.getters.userToken,
                    id: this.ordenpago.idOrdenPago,
                    mail: this.recipients
                })
                .then(response => (
                    this.sendcorreo = false,
                    this.previacorreo = false,
                    this.recipients = '',
                    this.$snotify.success(response.data.msg, 'Exito')
                ))
                .catch(error => (
                    this.previacorreo = false,
                    this.$snotify.error(error.response.data.response, 'Error')
                ))
           },
           sendDataOrdenpago: function (data, tipo) {
                this.bufferData = data
                // Convertir a factura
                if(tipo === 1){       
                    this.tipoDocConvert = 1,    
                    this.bodycomment = 'Esta a punto de convertir esta ordenpago en Factura' 
                // Convertir a boleta
                }else if(tipo === 2){            
                    this.tipoDocConvert = 2,
                    this.bodycomment = 'Esta a punto de convertir esta ordenpago en Boleta'
                // Convertir a guia de remision
                }else if(tipo === 3){       
                    this.tipoDocConvert = 3,    
                    this.bodycomment = 'Esta a punto de convertir esta ordenpago en Guia de Remision'
                }    
           },
           convertInvoice: function () {
              switch(this.tipoDocConvert){
                    case 1:
                        this.$store.commit('setordenpago', this.bufferData),
                        this.$router.push('/emision/factura').catch(err => {})
                        break;
                    case 2: 
                        this.$store.commit('setordenpago', this.bufferData),
                        this.$router.push('/emision/boleta').catch(err => {})
                        break;
                    case 3: 
                        this.$store.commit('setordenpago', this.bufferData),
                        this.$router.push('/emision/guia').catch(err => {})  
                        break;
              }
           },
           listOrdenPago: function () {
                this.isBusy = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ordenpago/listar', {
                    token: this.$store.getters.userToken,
                    page: this.currentPage,
                    limit: this.limite,
                    order: this.orden,
                    sistema:this.sistema
                })
                .then(response => (
                    this.isBusy = false,
                    this.ordenpagos = response.data.data,
                    this.total = response.data.total,
                    this.desde = response.data.from,
                    this.hasta = response.data.to
                ))
                .catch(error => {
                    this.$snotify.error(error.response.data.msg,'Error'),
                    this.isBusy = false
                })
            },
            returnProforma: function (index, item) {
                this.changeTab(4),
                this.editProforma(item)
            },
            initReturn: function () {
                let ordenpagoBlank = {}
                this.editProforma(ordenpagoBlank)
            },
            predeleteProforma: function (value) {
                this.$swal({
                title: 'Eliminar Proforma',
                text: 'Seguro de eliminar la ordenpago '+ value.serie +' - '+ value.numero,
                icon: 'error',
                buttons: true,
                dangerMode: true
                }).then((willDelete) => {
                    if(willDelete){
                        this.deleteProforma(value.idOrdenPago)        
                    }
                })
            },
            deleteProforma: function (value) {
                this.isBusy = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ordenpago/eliminar', {
                    token: this.$store.getters.userToken,
                    id: value
                })
                .then(response => (
                    this.listOrdenPago(),
                    this.$snotify.success(response.data.msg,'Exito')
                ))
                .catch(error => {
                    this.$snotify.error(error.response.data.msg,'Error')
                })
            },
            editProforma: function (value){
                this.$emit("ordenpago", value);
            },
            changeTab: function (value){
                this.$emit("tabindex", value);
            },
            sendPdf: function (row) {
                this.pdfordenpago = true,
                this.pdfobject = '',
                this.cargandopdf2 = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ordenpago/pdf', {
                    token: this.$store.getters.userToken,
                    id: row.item.idOrdenPago
                })
                .then(response => (
                    this.pdfobject = response.data.pdf,
                    this.cargandopdf2 = false
                ))
                .catch(error => {
                    this.cargandopdf2 = false,
                    this.pdfordenpago = false,
                    this.$snotify.error(error.response.data.msg,'Error')
                })
            },
            downloadPdf: function(data) {
            let tag = document.createElement("i");
            tag.classList.add("fa", "fa-spin", "fa-spinner");
            let name = data.serie + "-" + data.numero + ".pdf";
            let file = "data:application/pdf;base64," + data.pdf;
            this.cargandopdf = true;
            this.$swal({
                title: "Procesando Descarga",
                content: tag,
                icon: "info",
                buttons: false,
                dangerMode: false
            });
            axios
                .post(process.env.VUE_APP_API_URL + "ordenpago/pdf", {
                token: this.$store.getters.userToken,
                id: data.idOrdenPago
                })
                .then(
                response => {
                    const base64 = response.data.pdf;
                    const byteCharacters = atob(base64);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: "application/pdf" });
                    const url = URL.createObjectURL(blob);
                    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                    if (isIOS) {
                    window.location.href = url;
                    } else {
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = name;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    }
                    setTimeout(() => URL.revokeObjectURL(url), 5000);
                    this.cargandopdf = false;
                    this.$swal.close();
                })
                .catch(error => {
                this.$swal.close(),
                this.$snotify.error(error.response.data.msg, 'Error')
                })
            },
       }
    }
</script>

<style>
    .notice{
        font-size: 2em;
        color: #006666;
    }
    .tamanioletra {
        font-size: 13px;
        font-family: "Roboto Mono";
        margin-left: 3%;
        padding: 0px;
    }
</style>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto+Mono&display=swap");
</style>



